import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditvalutazionePage } from '../editvalutazione/editvalutazione';

/**
 * Generated class for the ValutazionePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-valutazione',
  templateUrl: 'valutazione.html',
})
export class ValutazionePage {
valutazioni;
i=0;
  constructor(public navCtrl: NavController, public navParams: NavParams, public rest: RestApiProvider, ) {
  }
  openValutazione(valutazione){
    //alert(JSON.stringify(valutazione))
    this.navCtrl.push(EditvalutazionePage, { valutazione: valutazione });

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad ValutazionePage');
  }
  ionViewWillEnter() {
    this.rest.getValutazioni().subscribe(valutazioni=>{
    //  alert(JSON.stringify(valutazioni));
      this.valutazioni=valutazioni
    })

  };

}



// WEBPACK FOOTER //
// ./src/pages/valutazione/valutazione.ts